export enum EnumUploadCarga {
    PENDENTE = 1,
    ANALISANDO = 2,
    AGUARDANDO = 3,
    CONFIRMACAO = 4,
    PROCESSADO = 5,
    CANCELADO = 6,
    REJEITADO = 7
}